module.exports = __webpack_public_path__ + "img/qrgzh.e2133102.jpg";